//find index of phase in given array
export const getPhaseIndex = (scheduleDate: string, phases: any, packageData: any) => {
    
    const testDate = new Date(scheduleDate);
    const len = phases.length;
    const lastPhaseEndDate = new Date(phases[len - 1].endDate);
    lastPhaseEndDate.setHours(23, 59, 59);
    for (let i = 0; i < len; i++) {
      const phaseStartDate = new Date(phases[i].startDate);
      let nextPhaseStartDate;
      if(i !== len - 1) {
        nextPhaseStartDate = new Date(phases[i+1].startDate);
      } else {
        nextPhaseStartDate =  (packageData && packageData.packageData && new Date(packageData.packageData.expiryDate)) ||
                                (packageData && new Date(packageData.expiryDate)); 
        
      }
      phaseStartDate.setHours(0 ,0 , 0);
      const phaseEndDate = new Date(phases[i].endDate);
      phaseEndDate.setHours(23, 59, 59);
      nextPhaseStartDate.setHours(0, 0, 0);
      if (phaseStartDate.getTime() <= testDate.getTime() && phaseEndDate.getTime() >= testDate.getTime()) {
        
        return i;
      }

      if(phaseEndDate.getTime() < testDate.getTime() && nextPhaseStartDate.getTime() > testDate.getTime()){
        
        return i
      } 
      
      if(lastPhaseEndDate.getTime() < testDate.getTime()) {
        
        return len - 1
      }
      
    }
    return -1;
  };
  
  // find index of week in given phase
  export const getWeekIndex = (scheduleDate: string, phase: any) => {
    const testDate = new Date(scheduleDate);
    const { weeks } = phase;
    const len = weeks && weeks.length ? weeks.length : 0;
    
    for (let i = 0; i < len; i++) {
      const weekStartDate = new Date(weeks[i].startDate);
      weekStartDate.setHours(0, 0, 0);
      const weekEndDate = new Date(weeks[i].endDate);
      weekEndDate.setHours(23, 59, 59);
      
      if (weekStartDate.getTime() <= testDate.getTime() && weekEndDate.getTime() >= testDate.getTime()) {
        return i;
      }
    }
    return -1;
  };

  // check if test already present
  export const isTestPresentInArray = (testName: string, testArray: any) => {
    const len = testArray.length;
    
    for (let i = 0; i < len; i++) {
      if (testArray[i].name === testName) return true;
    }
    return false;
  };
  